// extracted by mini-css-extract-plugin
export default {"errorContainer":"ActivityLogDetail_errorContainer__jQqcB","errorIcon":"ActivityLogDetail_errorIcon__tj2-K","errorCode":"ActivityLogDetail_errorCode__4rLvj"};